import { ParafinProduct } from '../../layers/entry/types'
import { Product } from '../../layers/product/types'

export const getEnvironmentChunk = (env: 'development' | 'production') => {
  return env === 'production' ? '' : '.dev'
}

const getDefaultWidgetUrl = (
  env: 'development' | 'production',
  variant: string
) => {
  switch (variant) {
    case 'button':
      return `https://button.widgets${getEnvironmentChunk(env)}.parafin.com`
    default:
      return `https://capital.widget${getEnvironmentChunk(env)}.parafin.com`
  }
}

export const getDefaultProduct = (
  env: 'development' | 'production',
  variant: string
) => {
  return {
    widgetURL: getDefaultWidgetUrl(env, variant),
    dashboardURL: `https://app${getEnvironmentChunk(env)}.parafin.com`,
    productSlug: 'capital',
    productName: 'Capital'
  }
}

const getProductChunk = (product: ParafinProduct) => {
  const productParam =
    product === 'merchant_cash_advance' ? 'cash_advance' : product
  return `?product=${productParam}`
}

export const getProduct = async (
  env: 'development' | 'production',
  token: string,
  productOverride: ParafinProduct,
  hasPreviewConfig: boolean
): Promise<Product> => {
  if (hasPreviewConfig) {
    return {
      widgetURL:
        productOverride === 'card'
          ? `https://card.widget${getEnvironmentChunk(env)}.parafin.com`
          : `https://capital.widget${getEnvironmentChunk(env)}.parafin.com`,
      dashboardURL: `https://app${getEnvironmentChunk(env)}.parafin.com`,
      productSlug: productOverride === 'card' ? 'card' : 'capital',
      productName: productOverride === 'card' ? 'Card' : 'Capital'
    }
  }

  const baseURL = `https://api${getEnvironmentChunk(env)}.parafin.com`
  const productChunk = getProductChunk(productOverride)

  const request = await fetch(`${baseURL}/products${productChunk}`, {
    headers: { authorization: `Bearer ${token}` }
  })

  const response = await request.json()
  const product = response.results[0]

  return {
    widgetURL: product.widget_url,
    dashboardURL: product.dashboard_url,
    productSlug: product.product_slug,
    productName: product.product_name
  }
}
